import script from "./JourneyDot.vue?vue&type=script&setup=true&lang=js"
export * from "./JourneyDot.vue?vue&type=script&setup=true&lang=js"

import "./JourneyDot.vue?vue&type=style&index=0&id=4b4cf0a2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b4cf0a2"]])

export default __exports__